import { css } from 'lit';

export default css`
  :host {
    display: flex;
    flex: 1;
    inline-size: 100%;
  }

  :host(:not(:first-of-type)) {
    border-block-start: var(--sl-color-border-plain) solid var(--sl-size-borderWidth-default);
    margin-block-start: var(--sl-size-075);
    padding-block-start: var(--sl-size-100);
  }

  ::slotted(sl-option:first-of-type) {
    margin-block-start: var(--sl-size-025);
  }

  [part='wrapper'] {
    flex: 1;
  }
`;
